// extracted by mini-css-extract-plugin
export default {"container":"oLvIM_Tz","title":"PDzKNVE1","subtitle":"Gp2SnZ2_","mobile":"mobile"};